import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = [ "position" ]
  static values = { handle: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.handleValue || null,
      animation: 150,
      ghostClass: "border-orange-300",
      filter: ".ProseMirror, .ProseMirror *, [data-rich-editor-target], .tiptap, input, select, textarea, button",
      preventOnFilter: false,

      onStart: (event) => {
        this.element.classList.add("is-dragging")
      },

      onEnd: () => {
        this.element.classList.remove("is-dragging")
        this.updatePositions()
      }
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  updatePositions() {
    this.positionTargets.forEach((input, index) => {
      input.value = index
    })
  }
}
